<template>
  <span>
    <span @click="openModalAction" class="link"><i class="fal fa-lock-alt"></i> 登録を解除</span>
  </span>
</template>

<script>

export default {
  components: {},
  data () {
    return {};
  },
  watch: {
    callback: function () {
      this.dialogCallback();
    },
    lock: function () {
      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }

    }
  },
  computed: {
    callback: function () {
      return this.$store.getters['message/callback'];
    }
  },
  methods: {
    openModalAction: function () {

      let option = {
        is2Button: true,
        buttonLabelL: '登録解除',
        buttonColorL: 'r',
        buttonLabelR: 'キャンセル',
        isButtonOnly: true,
        callbackL: 'unregister',
        callbackR: 'cancel',
        messages: ['登録を解除します', 'よろしいですか？']
      };

      this.$store.dispatch('message/open', option).then();

      scrollTo(0,0);
    },
    dialogCallback: function () {
      console.log('callback', this.callback);

      if (this.callback === 'unregister') {

        // 登録解除
        this.unregister();

      } else if (this.callback === 'unregisterFinish') {

        // welcomeへ遷移
        this.$router.push({name: 'Welcome'});

      }

    },
    unregister: function () {
      console.log('unregisterAction');

      if (this.lock) {
        console.log('lock', this.lock);
        return;
      }

      this.lock = true;

      this.$store.dispatch('user/unregister').then(() => {

        let status = this.$store.getters['user/status'];

        if (status === 200) {

          // 認証情報リセット
          this.$store.dispatch('auth/reset').then();
          this.$store.dispatch('user/reset').then();

          let option = {
            is1Button: true,
            buttonLabel: 'TOP',
            isButtonOnly: false,
            callback: 'unregisterFinish',
            callbackO: 'unregisterFinish',
            messages: ['登録を解除しました']
          };

          this.$store.dispatch('message/open', option).then();

        } else {
          this.$store.dispatch('errorInfo/setErrorStore', this.store).then();
          this.$router.push({name: 'UserSystemError'});
        }

        // ロック解除
        this.lock = false;

      }).catch((err) => {
        console.log(err);

        this.$store.dispatch('errorInfo/setErrorStore', this.store).then();
        this.$router.push({name: 'UserSystemError'});

        // ロック解除
        this.lock = false;

      });
    }
  }
};

</script>

<style lang="scss" scoped>

  .link {
    font-size: 14px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
  }

  // 801以上
  @media screen and (min-width: 801px) {

  }

  // 800まで
  @media screen and (max-width: 800px) {
  }

</style>
